import {
  apiContainer,
  queryBuilder,
  massageSingleRecordBeforeUpsert
} from './apiContainer'

const SLICE_API_ROOT = '/groups'
//POST https://<api-url>/groups/actions/assign_item
const groupsApi = apiContainer.injectEndpoints({
  endpoints: build => ({
    listGroups: build.query({
      query: args => queryBuilder(SLICE_API_ROOT, args)
    }),
    listExecutiveGroups: build.query({
      query: () => '/search/executive/groups'
    }),
    getOneGroup: build.query({
      query: args => queryBuilder(SLICE_API_ROOT, args),
      forceRefetch: true
    }),
    bulkUpdateGroups: build.mutation({
      query: args => {
        return {
          url: SLICE_API_ROOT,
          method: 'PATCH',
          body: { data: args }
        }
      }
    }),
    upsertGroup: build.mutation({
      query: args => {
        const { id } = args
        const actualArgs = massageSingleRecordBeforeUpsert(args)

        if (id) {
          // update

          return {
            url: `${SLICE_API_ROOT}/${id}`,
            method: 'PUT',
            body: actualArgs
          }
        } //insert
        else {
          return {
            url: SLICE_API_ROOT,
            method: 'POST',
            body: actualArgs
          }
        }
      }
    }),
    deleteGroup: build.mutation({
      query: args => {
        return {
          url: `${SLICE_API_ROOT}/${args.id}`,
          method: 'DELETE'
        }
      }
    })
  }),
  overrideExisting: true
})

export const {
  // the active load query is exported to speed up the initial detail record load,
  // which happens before the ui renders anything (way b4 the react mount hooks)
  // everything else should pretty much use the lazy load queries
  useGetOneGroupQuery,
  useLazyListGroupsQuery,
  useLazyListExecutiveGroupsQuery,
  useUpsertGroupMutation,
  useDeleteGroupMutation,
  useBulkUpdateGroupsMutation,
} = groupsApi
